module.exports = __webpack_public_path__ + "static/media/01.c1a8c14b.gif";